const logger = {
  log: (...args) => { if (process.env.NODE_ENV === 'development') console.log(...args); },
  warn: (...args) => { if (process.env.NODE_ENV === 'development') console.warn(...args); },
  error: (...args) => { console.error(...args); },
  debug: (...args) => { if (process.env.NODE_ENV === 'development') console.log('[debug]', ...args); },
};

export default logger;
